import React from 'react';
import { Helmet } from 'react-helmet';

function Home() {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      <Helmet>
        <title>Your App will be SUCCESS -- Pukser will do it for you!</title>
        <meta property="og:title" content="We'll create your app - PUKSER OÜ" />
      </Helmet>

      {/* Navbar */}
      <div className="navbar-container">
        <nav className="navbar">
          <div className="logo">
            <span className="logo-text">Pukser</span>
          </div>
          <div className="nav-links">
            <a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('features'); }}>Features</a>
            <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Services</a>
            <a href="#products" onClick={(e) => { e.preventDefault(); scrollToSection('products'); }}>Products</a>
            <a href="#testimonials" onClick={(e) => { e.preventDefault(); scrollToSection('testimonials'); }}>Testimonials</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact</a>
          </div>
          <div className="burger-menu">
            <svg viewBox="0 0 1024 1024">
              <path d="M128 256h768v86h-768v-86zM128 554v-84h768v84h-768zM128 768v-86h768v86h-768z"></path>
            </svg>
          </div>
        </nav>
      </div>

      {/* Hero */}
      <section className="hero">
        <div className="hero-text">
          <h1>We can build custom software.</h1>
          <p>
            Small but mighty, we are a dedicated team of full-stack developers
            passionate about crafting tailored software solutions. Whether it's
            a sleek mobile app, a robust web application, or a powerful backend,
            we have you covered.
          </p>
          <button className="cta-btn" onClick={() => scrollToSection('contact')}>
            CONTACT US
          </button>
        </div>
        <img
          src="https://images.unsplash.com/photo-1622050756792-5b1180bbb873?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDQ4fHxwcm9qZWN0fGVufDB8fHx8MTczMjAwNDc0Mnww&ixlib=rb-4.0.3&w=1500"
          alt="Custom Software Development"
          className="hero-image"
        />
      </section>

      {/* Features */}
      <section id="features" className="features">
        <div className="section-heading">
          <h2>Experienced Developers for Every Workflow</h2>
          <p>
            With 20+ years of combined experience working with startups and
            large corporations, our developers bring a wealth of knowledge to
            the table. We adapt seamlessly to your preferred workflow, whether
            it's fast-paced and highly agile or structured and waterfall.
          </p>
        </div>
        <div className="feature-cards">
          <div className="feature-card">
            <img
              src="https://images.unsplash.com/photo-1728382332631-94736587daeb?ixid=M3w5MTMyMXwwfDF8YWxsfDIyMnx8fHx8fHx8MTczMjAwNDI1NXw&ixlib=rb-4.0.3&w=400"
              alt="Agile Workflow"
            />
            <h3>Agile Workflow</h3>
            <p>
              Agile is all about flexibility and collaboration. We thrive in
              environments where priorities can shift, and feedback loops are
              rapid. Perfect for startups or fast-moving projects where
              innovation is key.
            </p>
          </div>
          <div className="feature-card">
            <img
              src="https://images.unsplash.com/photo-1465982046896-5172ca240f27?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDE0NHx8d2F0ZXJ8ZW58MHx8fHwxNzMyMDA0NzA4fDA&ixlib=rb-4.0.3&w=400"
              alt="Waterfall Workflow"
            />
            <h3>Waterfall Workflow</h3>
            <p>
              For projects with well-defined requirements and a clear end goal,
              we excel in the structured and linear approach of Waterfall. Ideal
              for large organizations with fixed timelines and deliverables.
            </p>
          </div>
          <div className="feature-card">
            <img
              src="https://images.unsplash.com/photo-1591484385394-f5083609ed6a?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDM1fHxwcm9qZWN0fGVufDB8fHx8MTczMjAwNDc0Mnww&ixlib=rb-4.0.3&w=400"
              alt="Project Management"
            />
            <h3>Project Management</h3>
            <p>
              Beyond just writing code, we bring value by helping you plan,
              coordinate, and deliver your project from start to finish. Our
              goal is to align technical execution with your business objectives.
            </p>
          </div>
        </div>
      </section>

      {/* Services */}
      <section id="services" className="services">
        <div className="services-grid">
          <div className="service-card">
            <h3>Custom Apps</h3>
            <p>
              Mobile and web apps designed to meet your unique needs.
            </p>
          </div>
          <div className="service-card">
            <h3>Full-Stack Development</h3>
            <p>
              Comprehensive expertise in front-end (React, React Native) and
              back-end (Golang, C#, Java).
            </p>
          </div>
          <div className="service-card">
            <h3>Database Expertise</h3>
            <p>
              Efficient and scalable database solutions using PostgreSQL and
              MongoDB.
            </p>
          </div>
          <div className="service-card">
            <h3>Quality Assurance</h3>
            <p>
              We ensure reliability by covering our code with unit tests and
              using human testers to validate the user interface.
            </p>
          </div>
        </div>
      </section>

      {/* Products */}
      <section id="products" className="products">
        <div className="section-heading">
          <h2>Our Products</h2>
          <p>
            In addition to custom development, we've built our own products that solve real-world problems.
          </p>
        </div>
        <div className="product-cards">
          <div className="product-card">
            <div className="product-icon">📱</div>
            <h3>Quizavvy</h3>
            <p>
              Quizavvy is a smart and social pub quiz companion app, designed for both quiz hosts and players.
              Create, play, and manage quizzes effortlessly — whether at the bar or from home.
              Available on the App Store and Google Play, Quizavvy brings trivia nights to life with smooth performance and intuitive design.
            </p>
            <a href="https://quizavvy.com" target="_blank" rel="noopener noreferrer" className="product-link">
              Visit quizavvy.com →
            </a>
          </div>
          <div className="product-card">
            <div className="product-icon">💼</div>
            <h3>HR / Payroll</h3>
            <p>
              Our HR & Payroll system streamlines everything from employee management and contract tracking to payroll and vacation calendars.
              Built with modern businesses in mind, it ensures accuracy, compliance, and efficiency for HR teams and accountants alike.
              Trusted by professionals who value simplicity and control.
            </p>
            <a href="https://login.trf.is" target="_blank" rel="noopener noreferrer" className="product-link">
              Visit TRF.is →
            </a>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section id="testimonials" className="testimonials">
        <h2>What are they saying about us?</h2>
        <div className="testimonial-cards">
          <div className="testimonial-card">
            <div className="testimonial-header">
              <div className="testimonial-info">
                <h4>Will Evans</h4>
                <p>Freelance Dev</p>
              </div>
              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} viewBox="0 0 950.8571428571428 1024">
                    <path d="M950.857 369.714c0 10.286-7.429 20-14.857 27.429l-207.429 202.286 49.143 285.714c0.571 4 0.571 7.429 0.571 11.429 0 14.857-6.857 28.571-23.429 28.571-8 0-16-2.857-22.857-6.857l-256.571-134.857-256.571 134.857c-7.429 4-14.857 6.857-22.857 6.857-16.571 0-24-13.714-24-28.571 0-4 0.571-7.429 1.143-11.429l49.143-285.714-208-202.286c-6.857-7.429-14.286-17.143-14.286-27.429 0-17.143 17.714-24 32-26.286l286.857-41.714 128.571-260c5.143-10.857 14.857-23.429 28-23.429s22.857 12.571 28 23.429l128.571 260 286.857 41.714c13.714 2.286 32 9.143 32 26.286z"></path>
                  </svg>
                ))}
              </div>
            </div>
            <p>
              Quick job! Thanks guys for the collab! Test driven development is awesome! You rock!
            </p>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-header">
              <div className="testimonial-info">
                <h4>Marie Alba</h4>
                <p>CEMMAPF Ltd</p>
              </div>
              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} viewBox="0 0 950.8571428571428 1024">
                    <path d="M950.857 369.714c0 10.286-7.429 20-14.857 27.429l-207.429 202.286 49.143 285.714c0.571 4 0.571 7.429 0.571 11.429 0 14.857-6.857 28.571-23.429 28.571-8 0-16-2.857-22.857-6.857l-256.571-134.857-256.571 134.857c-7.429 4-14.857 6.857-22.857 6.857-16.571 0-24-13.714-24-28.571 0-4 0.571-7.429 1.143-11.429l49.143-285.714-208-202.286c-6.857-7.429-14.286-17.143-14.286-27.429 0-17.143 17.714-24 32-26.286l286.857-41.714 128.571-260c5.143-10.857 14.857-23.429 28-23.429s22.857 12.571 28 23.429l128.571 260 286.857 41.714c13.714 2.286 32 9.143 32 26.286z"></path>
                  </svg>
                ))}
              </div>
            </div>
            <p>
              Will order next phase of the IS soon. The MVP went well.
            </p>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-header">
              <div className="testimonial-info">
                <h4>Taylor Sam</h4>
                <p>PM</p>
              </div>
              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} viewBox="0 0 950.8571428571428 1024">
                    <path d="M950.857 369.714c0 10.286-7.429 20-14.857 27.429l-207.429 202.286 49.143 285.714c0.571 4 0.571 7.429 0.571 11.429 0 14.857-6.857 28.571-23.429 28.571-8 0-16-2.857-22.857-6.857l-256.571-134.857-256.571 134.857c-7.429 4-14.857 6.857-22.857 6.857-16.571 0-24-13.714-24-28.571 0-4 0.571-7.429 1.143-11.429l49.143-285.714-208-202.286c-6.857-7.429-14.286-17.143-14.286-27.429 0-17.143 17.714-24 32-26.286l286.857-41.714 128.571-260c5.143-10.857 14.857-23.429 28-23.429s22.857 12.571 28 23.429l128.571 260 286.857 41.714c13.714 2.286 32 9.143 32 26.286z"></path>
                  </svg>
                ))}
              </div>
            </div>
            <p>
              Product was cool. Need to pivot my startup then order new features.
            </p>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="contact">
        <div className="contact-container">
          <div className="contact-content">
            <h2>This is where to find us</h2>
            <div className="locations">
              <div className="location">
                <h3>Tartu Office</h3>
                <div className="location-item">
                  <svg viewBox="0 0 1024 1024">
                    <path d="M512 0c-176.732 0-320 143.268-320 320 0 320 320 704 320 704s320-384 320-704c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z"></path>
                  </svg>
                  <span>Tartu</span>
                </div>
                <div className="location-item">
                  <svg viewBox="0 0 1024 1024">
                    <path d="M854 342v-86l-342 214-342-214v86l342 212zM854 170q34 0 59 26t25 60v512q0 34-25 60t-59 26h-684q-34 0-59-26t-25-60v-512q0-34 25-60t59-26h684z"></path>
                  </svg>
                  <span>toomas@pukser.ee</span>
                </div>
                <div className="location-item">
                  <svg viewBox="0 0 804.5714285714286 1024">
                    <path d="M804.571 708.571c0 20.571-9.143 60.571-17.714 79.429-12 28-44 46.286-69.714 60.571-33.714 18.286-68 29.143-106.286 29.143-53.143 0-101.143-21.714-149.714-39.429-34.857-12.571-68.571-28-100-47.429-97.143-60-214.286-177.143-274.286-274.286-19.429-31.429-34.857-65.143-47.429-100-17.714-48.571-39.429-96.571-39.429-149.714 0-38.286 10.857-72.571 29.143-106.286 14.286-25.714 32.571-57.714 60.571-69.714 18.857-8.571 58.857-17.714 79.429-17.714 4 0 8 0 12 1.714 12 4 24.571 32 30.286 43.429 18.286 32.571 36 65.714 54.857 97.714 9.143 14.857 26.286 33.143 26.286 50.857 0 34.857-103.429 85.714-103.429 116.571 0 15.429 14.286 35.429 22.286 49.143 57.714 104 129.714 176 233.714 233.714 13.714 8 33.714 22.286 49.143 22.286 30.857 0 81.714-103.429 116.571-103.429 17.714 0 36 17.143 50.857 26.286 32 18.857 65.143 36.571 97.714 54.857 11.429 5.714 39.429 18.286 43.429 30.286 1.714 4 1.714 8 1.714 12z"></path>
                  </svg>
                  <span>+372 56 648 133</span>
                </div>
              </div>
              <div className="location"  style={{ display: 'none' }}>
                <h3>Luunja Office</h3>
                <div className="location-item">
                  <svg viewBox="0 0 1024 1024">
                    <path d="M512 0c-176.732 0-320 143.268-320 320 0 320 320 704 320 704s320-384 320-704c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z"></path>
                  </svg>
                  <span>Luunja</span>
                </div>
                <div className="location-item">
                  <svg viewBox="0 0 1024 1024">
                    <path d="M854 342v-86l-342 214-342-214v86l342 212zM854 170q34 0 59 26t25 60v512q0 34-25 60t-59 26h-684q-34 0-59-26t-25-60v-512q0-34 25-60t59-26h684z"></path>
                  </svg>
                  <span>kaire@pukser.ee</span>
                </div>
                <div className="location-item">
                  <svg viewBox="0 0 804.5714285714286 1024">
                    <path d="M804.571 708.571c0 20.571-9.143 60.571-17.714 79.429-12 28-44 46.286-69.714 60.571-33.714 18.286-68 29.143-106.286 29.143-53.143 0-101.143-21.714-149.714-39.429-34.857-12.571-68.571-28-100-47.429-97.143-60-214.286-177.143-274.286-274.286-19.429-31.429-34.857-65.143-47.429-100-17.714-48.571-39.429-96.571-39.429-149.714 0-38.286 10.857-72.571 29.143-106.286 14.286-25.714 32.571-57.714 60.571-69.714 18.857-8.571 58.857-17.714 79.429-17.714 4 0 8 0 12 1.714 12 4 24.571 32 30.286 43.429 18.286 32.571 36 65.714 54.857 97.714 9.143 14.857 26.286 33.143 26.286 50.857 0 34.857-103.429 85.714-103.429 116.571 0 15.429 14.286 35.429 22.286 49.143 57.714 104 129.714 176 233.714 233.714 13.714 8 33.714 22.286 49.143 22.286 30.857 0 81.714-103.429 116.571-103.429 17.714 0 36 17.143 50.857 26.286 32 18.857 65.143 36.571 97.714 54.857 11.429 5.714 39.429 18.286 43.429 30.286 1.714 4 1.714 8 1.714 12z"></path>
                  </svg>
                  <span>+372 53303727</span>
                </div>
              </div>
            </div>
            <div className="social-links">
              <svg viewBox="0 0 950.8571428571428 1024">
                <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
              </svg>
              <svg viewBox="0 0 877.7142857142857 1024">
                <path d="M713.143 73.143c90.857 0 164.571 73.714 164.571 164.571v548.571c0 90.857-73.714 164.571-164.571 164.571h-107.429v-340h113.714l17.143-132.571h-130.857v-84.571c0-38.286 10.286-64 65.714-64l69.714-0.571v-118.286c-12-1.714-53.714-5.143-101.714-5.143-101.143 0-170.857 61.714-170.857 174.857v97.714h-114.286v132.571h114.286v340h-304c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571z"></path>
              </svg>
              <svg viewBox="0 0 877.7142857142857 1024">
                <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
              </svg>
            </div>
          </div>
          <img
            src="https://images.unsplash.com/photo-1730407401172-aeed1b1ace5b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8YWxsfDI0M3x8fHx8fHx8MTczMjAwNDI2MXw&ixlib=rb-4.0.3&q=80&w=800"
            alt="Contact"
            className="contact-image"
          />
        </div>
      </section>
    </div>
  );
}

export default Home;